export default "__VITE_ASSET__5b7b2167__"